<template>
  <div id="course">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <Title>{{ course.title }}</Title>
    <p>{{ course.description }}</p>
    <SubTitle>Lessons included in this course</SubTitle>
    <ul class="my-4 py-0">
      <li v-for="(lesson, i) in course.lessons" :key="'li' + i">
        <router-link :to="{ name: 'lesson', params: { id: lesson.id } }">{{
          lesson.title
        }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import CoursesAPI from "@/api/apiCourses";

export default {
  name: "CoursePage",
  components: {
    // Course
  },
  props: {
    id: [String, Number]
  },
  data() {
    return {
      course: {},
      breadcrumbs: [
        {
          text: "Courses",
          disabled: false,
          to: { name: "courses" }
        }
      ]
    };
  },
  async mounted() {
    try {
      this.course = await CoursesAPI.getCourse(this.id);
      this.breadcrumbs.push({ text: this.course.title, disabled: true });
    } catch (e) {
      console.error(e);
    }
  }
};
</script>
<style scoped>
ul {
  list-style: numbered;
}
li > a {
  font-weight: 700;
}
</style>
